import { validScenes, fillMap, sceneData } from '@/util/sceneMap'
import updateOnScroll from 'uos'
import { styler, timeline, transform } from 'popmotion'
const { interpolate } = transform

export default {
    props: {
        rootElement: {
            type: SVGSVGElement,
            required: true
        }
    },

    data() {
        return {
            animation: null,
            progress: 0
        }
    },

    computed: {
        vennGroupStyler() {
            return styler(this.rootElement.querySelector('#venn-diagram'))
        },

        vennStylers() {
            return validScenes
                .filter(s => s != 'intro' && s != 'landing')
                .map(s => ({
                    element: this.rootElement.querySelector(`#${s}`),
                    scene: s,
                    styler: styler(this.rootElement.querySelector(`#${s}`)),
                    fillOpacity: fillMap.get(s)
                }))
        },

        titleStylers() {
            return validScenes
                .filter(s => s != 'intro' && s != 'landing' && s != 'overview')
                .map(s => this.rootElement.querySelector(`#${s}-title`))
                .map(e => styler(e))
        },

        action() {
            return timeline([
                [
                    { track: 'path', from: 0, to: 100 },
                    { track: 'group', from: 180, to: 0 },
                    { track: 'title', from: 0, to: 1 },
                    100
                ]
            ])
        },

        reaction() {
            return values => {
                this.vennGroupStyler.set({ rotate: values.group })
                this.vennStylers.forEach(o =>
                    o.styler.set({
                        pathLength: values.path,
                        fillOpacity: o.fillOpacity * values.title
                    })
                )
                this.titleStylers.forEach(styler =>
                    styler.set({ opacity: values.title })
                )
            }
        },

        interpolate() {
            return interpolate([0, 0.15, 1], [0, 0, 1])
        },

        progressInterpolated() {
            return this.interpolate(this.progress)
        }
    },

    watch: {
        progressInterpolated(p, oldp) {
            if (p === oldp) return

            if (this.animation && this.animation.seek) {
                this.animation.seek(p)
            }
        }
    },

    mounted() {
        let [start, end] = sceneData.intro.scrollProgress
        this.uos = updateOnScroll(start, end, progress => {
            this.progress = progress
        })
        this.init()
    },

    beforeDestroy() {
        this.uos()
        this.uninit()
    },

    methods: {
        init() {
            this.vennStylers.map(o =>
                o.styler.set({ pathLength: 0, fillOpacity: 0 })
            )
            this.titleStylers.map(styler => styler.set({ opacity: 0 }))

            this.animation = this.action.start(this.reaction)
            this.animation.pause()
        },
        uninit() {
            this.vennStylers.map(o =>
                o.styler.set({ pathLength: 100, fillOpacity: o.fillOpacity })
            )
            this.titleStylers.map(styler => styler.set({ opacity: 1 }))
        }
    },

    render: () => null
}
